(function () {
  if (sessionStorage.getItem('aiof_popup_shown')) return;

  var DELAY_MS = 4000;
  var DISCOUNT_CODE = 'BIENVENIDA10';

  function buildPopup() {
    var overlay = document.createElement('div');
    overlay.id = 'aiof-email-popup-overlay';
    overlay.innerHTML = `
      <div id="aiof-email-popup">
        <button id="aiof-popup-close" aria-label="Cerrar">&times;</button>
        <h2>10% de Descuento</h2>
        <p>Únete a la familia All in One Fragrance y recibe <strong>10% OFF</strong> en tu primera compra.</p>
        <form id="aiof-popup-form">
          <input type="email" id="aiof-popup-email" placeholder="Tu correo electrónico" required />
          <button type="submit">Quiero mi Descuento</button>
        </form>
        <p class="aiof-popup-fine">Sin spam. Cancela cuando quieras.</p>
      </div>
    `;
    document.body.appendChild(overlay);

    document.getElementById('aiof-popup-close').addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    document.getElementById('aiof-popup-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('aiof-popup-email').value;

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&utf8=%E2%9C%93&contact[tags]=newsletter&contact[email]=' + encodeURIComponent(email)
      }).catch(function () {});

      showSuccess();
    });
  }

  function showSuccess() {
    var popup = document.getElementById('aiof-email-popup');
    popup.innerHTML = `
      <button id="aiof-popup-close" aria-label="Cerrar">&times;</button>
      <h2>¡Listo! 🎉</h2>
      <p>Usa este código en tu próxima compra:</p>
      <div class="aiof-popup-code">${DISCOUNT_CODE}</div>
      <button id="aiof-popup-continue">Ir de Compras</button>
    `;
    document.getElementById('aiof-popup-close').addEventListener('click', closePopup);
    document.getElementById('aiof-popup-continue').addEventListener('click', closePopup);
  }

  function closePopup() {
    var overlay = document.getElementById('aiof-email-popup-overlay');
    if (overlay) overlay.remove();
    sessionStorage.setItem('aiof_popup_shown', '1');
  }

  if (window.location.pathname === '/' || window.location.pathname === '/es' || window.location.pathname === '/es/') {
    setTimeout(buildPopup, DELAY_MS);
  }
})();
